import { defineMessages } from 'react-intl';

/** The words of the editor shell: the top bar, the tabs and the publish states (design a1–a4, a8). */
export const editorMessages = defineMessages({
  crumb: { id: 'app.sml.smartlinks.editor.crumb', defaultMessage: 'Promote / SmartLinks' },
  back: { id: 'app.sml.smartlinks.editor.back', defaultMessage: 'Back to your SmartLinks' },
  kindSong: { id: 'app.sml.smartlinks.editor.kind.song', defaultMessage: 'Song page' },
  kindBioLink: { id: 'app.sml.smartlinks.editor.kind.bio_link', defaultMessage: 'Your artist page' },
  bioLinkName: { id: 'app.sml.smartlinks.editor.bio_link_name', defaultMessage: 'Your Bio Link' },
  addressChip: { id: 'app.sml.smartlinks.editor.address_chip', defaultMessage: 'Change the address' },
  statusDraft: { id: 'app.sml.smartlinks.editor.status.draft', defaultMessage: 'Draft · not live' },
  statusUpToDate: { id: 'app.sml.smartlinks.editor.status.up_to_date', defaultMessage: 'Live · up to date' },
  statusPending: {
    id: 'app.sml.smartlinks.editor.status.pending',
    defaultMessage: 'Live · {count, plural, one {# change} other {# changes}} not live',
  },
  statusPendingNoCount: {
    id: 'app.sml.smartlinks.editor.status.pending_no_count',
    defaultMessage: 'Live · changes not live',
  },
  pendingShort: {
    id: 'app.sml.smartlinks.editor.status.pending_short',
    defaultMessage: '{count, plural, one {# change} other {# changes}} not live',
  },
  pendingShortNoCount: {
    id: 'app.sml.smartlinks.editor.status.pending_short_no_count',
    defaultMessage: 'Changes not live',
  },
  openPage: { id: 'app.sml.smartlinks.editor.open_page', defaultMessage: 'Open page' },
  preview: { id: 'app.sml.smartlinks.editor.preview', defaultMessage: 'Preview' },
  publish: { id: 'app.sml.smartlinks.editor.publish', defaultMessage: 'Publish' },
  publishChanges: { id: 'app.sml.smartlinks.editor.publish_changes', defaultMessage: 'Publish changes' },
  publishing: { id: 'app.sml.smartlinks.editor.publishing', defaultMessage: 'Publishing' },
  saving: { id: 'app.sml.smartlinks.editor.saving', defaultMessage: 'Saving…' },
  fixBlocksFirst: {
    id: 'app.sml.smartlinks.editor.fix_blocks_first',
    defaultMessage: '{count, plural, one {Fix # block first} other {Fix # blocks first}}',
  },
  fixBlocksHelp: {
    id: 'app.sml.smartlinks.editor.fix_blocks_help',
    defaultMessage: 'A block has a field that is not right, so it is not saved. Fix it or close it, then publish.',
  },
  saveFailed: {
    id: 'app.sml.smartlinks.editor.save_failed',
    defaultMessage: 'A change did not save. Try again.',
  },
  publishNoBlocks: {
    id: 'app.sml.smartlinks.editor.publish_no_blocks',
    defaultMessage: 'Add a block to publish the page.',
  },
  publishDone: { id: 'app.sml.smartlinks.editor.publish_done', defaultMessage: 'Your changes are live.' },
  publishFailed: {
    id: 'app.sml.smartlinks.editor.publish_failed',
    defaultMessage: 'We could not publish the page. Your changes are safe. Try again.',
  },
  slugTaken: {
    id: 'app.sml.smartlinks.editor.slug_taken',
    defaultMessage: 'Another page uses {address}. Pick a new end of the address in Page, then publish.',
  },
  slugTakenUse: { id: 'app.sml.smartlinks.editor.slug_taken_use', defaultMessage: 'Use {slug}' },
  slugTakenPick: { id: 'app.sml.smartlinks.editor.slug_taken_pick', defaultMessage: 'Open Page' },
  tabBlocks: { id: 'app.sml.smartlinks.editor.tab.blocks', defaultMessage: 'Blocks' },
  tabLook: { id: 'app.sml.smartlinks.editor.tab.look', defaultMessage: 'Look' },
  tabPage: { id: 'app.sml.smartlinks.editor.tab.page', defaultMessage: 'Page' },
  tabsLabel: { id: 'app.sml.smartlinks.editor.tabs_label', defaultMessage: 'Editor sections' },
  stageHint: { id: 'app.sml.smartlinks.editor.stage_hint', defaultMessage: 'Click a block on the page to edit it.' },
  backToEditor: { id: 'app.sml.smartlinks.editor.back_to_editor', defaultMessage: 'Edit' },
  close: { id: 'app.sml.smartlinks.editor.close', defaultMessage: 'Close' },
});
